export const PACKET_PREFIX = '02';
export const PACKET_SUFFIX = '0d';
